import i18next from 'i18next';
import React from 'react';

import { Button } from '@commons/utils/styledLibraryComponents';

export const getActions = (addNewStoresProductionPlanning, readOnly, props) => [
  {
    id: 'action-add',
    fixed: true,
    actionLabel: i18next.t('GENERAL.ADD'),
    handleAction: () => addNewStoresProductionPlanning(props),
    render: () => (
      <Button
        color={'inpulse-default'}
        handleClick={() => addNewStoresProductionPlanning(props)}
        icon={'/images/inpulse/add-white-small.svg'}
        isDisabled={readOnly}
        label={i18next.t('GENERAL.ADD')}
      />
    ),
  },
];

export const getRowActions = (confirmDeletion, props) => [
  {
    id: 'delete-association',
    actionLabel: () => i18next.t('ADMIN.PRODUCTS.DELETE_CASHIER_PRODUCT_ASSOCIATION'),
    handleAction: (selectedStore) => confirmDeletion(selectedStore, props),
    actionIcon: () => '/images/inpulse/trash-black-small.svg',
  },
];
